module.exports = __webpack_public_path__ + "3ada54be76aca33abda7cddc56813fb3.pdf";